

export const fetchData = async (routeURL, headers) => {
    
    let token = localStorage.getItem("token");

    return new Promise((resolve, reject) => {

      fetch(routeURL, {
        method : 'GET',
        headers: {
          'Content-Type': 'application/json',
          authorization: `Bearer ${token}`,
          ...headers
        }
      } )
      .then((response) => response.json())
      .then((data) => {

            if(!data.status && data.message === "jwt expired"){
              localStorage.clear();
            }
            const token = data['access-token'];
            if(token){
              localStorage.setItem('token', token);
            }
            
            
            resolve(JSON.stringify(data));
          }
      ).catch((error) => {
        console.error('Error:', error);
        reject(error);
      });



    })
  };

  export const PostData =  (routeURL, postData, headers) => {
    console.log(routeURL)
    let token = localStorage.getItem("token");
    
    
    return new Promise((resolve, reject)=>{
  
      fetch(routeURL, {
        method: 'POST', 
        headers: {
          'Content-Type': 'application/json',
          authorization: `Bearer ${token}`,
          ...headers
        },
        body: JSON.stringify(postData),
      }).then((response) =>  response.json())
      .then((data) => {
        console.log(data)
          const token = data['access-token'];
          if(token){
            localStorage.setItem('token', token);
          }
          if(routeURL === '/api/user/login'   ){
            localStorage.setItem('qtrackuser', JSON.stringify(data));
          }
          resolve(data);
      })
      .catch((error) => {
        console.error('Error:', error);
        reject(error)
      });
    })
      
  };
  